var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWsubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.0774,
    cy: 19,
    rx: 19.6204,
    ry: 19,
    fill: "#4F4E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 19.4L9.6001 15.5L13.5001 11.6L17.4001 15.5L13.5001 19.4ZM17.0001 29V24C15.9834 23.9167 14.9751 23.7957 13.9751 23.637C12.9751 23.4783 11.9834 23.266 11.0001 23L11.5001 21C12.9001 21.3833 14.3044 21.646 15.7131 21.788C17.1218 21.93 18.5508 22.0007 20.0001 22C21.4501 22 22.8794 21.929 24.2881 21.787C25.6968 21.645 27.1008 21.3827 28.5001 21L29.0001 23C28.0168 23.2667 27.0251 23.4793 26.0251 23.638C25.0251 23.7967 24.0168 23.9173 23.0001 24V29H17.0001ZM20.0001 14C19.1668 14 18.4584 13.7083 17.8751 13.125C17.2918 12.5417 17.0001 11.8333 17.0001 11C17.0001 10.1667 17.2918 9.45833 17.8751 8.875C18.4584 8.29167 19.1668 8 20.0001 8C20.8334 8 21.5418 8.29167 22.1251 8.875C22.7084 9.45833 23.0001 10.1667 23.0001 11C23.0001 11.8333 22.7084 12.5417 22.1251 13.125C21.5418 13.7083 20.8334 14 20.0001 14ZM20.0001 21C19.4501 21 18.9791 20.804 18.5871 20.412C18.1951 20.02 17.9994 19.5493 18.0001 19C18.0001 18.45 18.1961 17.979 18.5881 17.587C18.9801 17.195 19.4508 16.9993 20.0001 17C20.5501 17 21.0211 17.196 21.4131 17.588C21.8051 17.98 22.0008 18.4507 22.0001 19C22.0001 19.55 21.8041 20.021 21.4121 20.413C21.0201 20.805 20.5494 21.0007 20.0001 21ZM25.0501 19L23.3501 16L25.0501 13H28.4501L30.1501 16L28.4501 19H25.0501Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsubtract);
export default __webpack_public_path__ + "static/media/wsubtract.4d49a1dc35a85c22f8d1dddec5266d40.svg";
export { ForwardRef as ReactComponent };